module.exports = __webpack_public_path__ + "static/media/search-normal.01e7deae.svg";